import * as React from 'react'

export const Telescope = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_431_772)">
      <path
        d="M2.34388 34.0242L0.0703882 25.5365C-0.222737 24.4426 0.426404 23.3183 1.52029 23.025L12.5144 20.0782C13.6084 19.7849 14.7336 20.4353 15.0263 21.5285L17.2997 30.0163C17.5927 31.1102 16.9435 32.2345 15.8498 32.5278L4.85582 35.4746C4.31961 35.6182 2.76019 35.5787 2.34388 34.0242Z"
        fill="#8C635F"
      />
      <path
        d="M4.85566 35.4741L15.8496 32.5273C16.9434 32.234 17.5925 31.1098 17.2995 30.0158L16.1627 25.7715L1.20801 29.784L2.34359 34.0238C2.76004 35.5783 4.31945 35.6178 4.85566 35.4741Z"
        fill="#63433F"
      />
      <path
        d="M13.9085 33.2003L10.4929 20.4698C10.1993 19.3757 10.8494 18.2505 11.9426 17.9575L33.1619 12.2716C34.2563 11.9784 35.3802 12.6275 35.6734 13.7211L39.0892 26.4515C39.3827 27.5457 38.7326 28.6709 37.6394 28.9639L16.42 34.6498C15.2673 34.9587 14.1858 34.234 13.9085 33.2003Z"
        fill="#AA7F7A"
      />
      <path
        d="M16.4201 34.6505L37.6395 28.9646C38.7327 28.6716 39.383 27.5464 39.0893 26.4523L37.3795 20.0801L12.2007 26.8358L13.9086 33.201C14.1857 34.2347 15.2673 34.9595 16.4201 34.6505Z"
        fill="#815E59"
      />
      <path
        d="M35.6988 29.6357L31.1519 12.6613C30.8588 11.5674 31.5079 10.443 32.6018 10.1498L53.8101 4.465C54.9035 4.17146 56.0291 4.82197 56.322 5.91517L60.869 22.8895C61.1621 23.9834 60.513 25.1078 59.4191 25.401L38.2107 31.0859C37.6298 31.2418 36.1068 31.1588 35.6988 29.6357Z"
        fill="#B48C87"
      />
      <path
        d="M38.2108 31.0866L59.4192 25.4016C60.5131 25.1084 61.1622 23.9841 60.8691 22.8901L58.5918 14.3887L33.4233 21.1416L35.6987 29.6362C36.1069 31.1594 37.6299 31.2424 38.2108 31.0866Z"
        fill="#9F7772"
      />
      <path
        d="M57.4776 26.073L51.7992 4.85483C51.5065 3.76108 52.1555 2.63712 53.2491 2.34386L61.728 0.0703602C62.8215 -0.222628 63.9467 0.426102 64.24 1.52013L69.9292 22.7372C70.2226 23.8315 69.5724 24.9565 68.4792 25.2493L59.9892 27.5239C59.4545 27.6672 57.8935 27.6279 57.4776 26.073Z"
        fill="#E9BEB8"
      />
      <path
        d="M59.9894 27.5242L68.4793 25.2496C69.5725 24.9567 70.2227 23.8318 69.9293 22.7375L67.08 12.1113L54.6348 15.4505L57.4776 26.0735C57.8935 27.6284 59.4545 27.6676 59.9894 27.5242Z"
        fill="#CFA29C"
      />
      <path
        d="M54.7717 67.0814L40.6693 36.8746C40.3322 36.1527 39.6074 35.6913 38.8108 35.6914C38.0141 35.6913 37.2893 36.1527 36.9522 36.8746L22.8498 67.0814C22.3706 68.1077 22.8142 69.3281 23.8405 69.8073C24.8668 70.2862 26.087 69.8429 26.5664 68.8166L38.8109 42.5894L51.0554 68.8166C51.5348 69.8429 52.755 70.2862 53.7813 69.8073C54.8073 69.3281 55.2509 68.1077 54.7717 67.0814Z"
        fill="#AA7F7A"
      />
      <path
        d="M54.7715 67.0814L40.6691 36.8746C40.332 36.1527 39.6072 35.6913 38.8105 35.6914V42.5893L51.0551 68.8165C51.5344 69.8428 52.7546 70.2861 53.781 69.8071C54.8071 69.3281 55.2507 68.1077 54.7715 67.0814Z"
        fill="#805E59"
      />
      <path
        d="M38.8112 39.7922C35.258 39.7922 32.3672 36.9014 32.3672 33.3483C32.3672 29.7951 35.258 26.9043 38.8112 26.9043C42.3643 26.9043 45.2553 29.7951 45.2553 33.3483C45.2553 36.9014 42.3643 39.7922 38.8112 39.7922Z"
        fill="#8C635F"
      />
      <path
        d="M38.811 39.7924V26.9043C42.3642 26.9043 45.2551 29.7951 45.2551 33.3483C45.2551 36.9014 42.3642 39.7924 38.811 39.7924Z"
        fill="#63433F"
      />
    </g>
    <defs>
      <clipPath id="clip0_431_772">
        <rect width="70" height="70" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
